import { useState, useRef, useEffect } from "react";
import ArrowLeft from "components/Icon/ArrowLeft";
import ArrowRight from "components/Icon/ArrowRight";
import { color as colorList } from "utils/color";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { getBase64, dataURLtoFile, matchYoutubeUrl } from "utils/imageHelper";

import MediaCard from "components/UpStyled/MediaCard";
import SuiBox from "components/SuiBox";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";

import breakpoints from "assets/theme/base/breakpoints";

import "swiper/css";
import "swiper/css/navigation";

const responsive = {
  xl5: {
    breakpoint: { max: 8000, min: 2600 },
    items: 8,
  },
  xl4: {
    breakpoint: { max: 2600, min: 2200 },
    items: 7,
  },
  xl4: {
    breakpoint: { max: 2200, min: 1800 },
    items: 6,
  },
  xl3: {
    breakpoint: { max: 1800, min: 1600 },
    items: 5,
  },
  xxl: {
    breakpoint: { max: 1600, min: 1400 },
    items: 5,
  },
  xl: {
    breakpoint: { max: 1400, min: 1200 },
    items: 4,
  },
  lg: {
    breakpoint: { max: 1200, min: 992 },
    items: 4,
  },
  md: {
    breakpoint: { max: 992, min: 768 },
    items: 3,
  },
  sm: {
    breakpoint: { max: 768, min: 576 },
    items: 2,
  },
  xs: {
    breakpoint: { max: 576, min: 0 },
    items: 1,
  },
};

const MyCarousel = ({ data }) => {
  const maxScrollWidth = useRef(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const carousel = useRef(null);

  const movePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prevState) => prevState - 1);
    }
  };

  const moveNext = () => {
    if (carousel.current && carousel.current.offsetWidth * currentIndex <= maxScrollWidth.current) {
      setCurrentIndex((prevState) => prevState + 1);
    }
    console.log("next");
  };

  useEffect(() => {
    if (carousel && carousel.current) {
      carousel.current.scrollLeft = carousel.current.offsetWidth * currentIndex;
    }
  }, [currentIndex]);

  useEffect(() => {
    maxScrollWidth.current = carousel.current
      ? carousel.current.scrollWidth - carousel.current.offsetWidth
      : 0;
  }, []);

  return (
    <Swiper
      slidesPerView={1}
      spaceBetween={10}
      pagination={{
        clickable: true,
      }}
      navigation={true}
      breakpoints={{
        576: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 50,
        },
        1400: {
          slidesPerView: 6,
          spaceBetween: 50,
        },
      }}
      modules={[Pagination, Navigation]}
      className="mySwiper"
    >
      {data.map((item, index) => {
        if (item.startsWith("blob") || matchYoutubeUrl(item) || item.endsWith(".mp4")) {
          return (
            <SwiperSlide>
              <MediaCard src={item} type="video" />
            </SwiperSlide>
          );
        } else {
          return (
            <SwiperSlide>
              <MediaCard src={item} type="image" />
            </SwiperSlide>
          );
        }
      })}
    </Swiper>
  );
};

export default MyCarousel;
